import { render, staticRenderFns } from "./comparacionliq.vue?vue&type=template&id=088ea32a"
import script from "./comparacionliq.vue?vue&type=script&lang=js"
export * from "./comparacionliq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports